import { pathBuilder } from 'config/paths/index';

export const root = '/analytics';
export default pathBuilder(root);
